import {Injectable} from '@angular/core';
import {CoreService, ErrorMessage, HttpClientService} from "inet-core";
import {Observable} from "rxjs";

declare var JitsiMeetExternalAPI: any;
declare let iNet: any;

@Injectable({
  providedIn: 'platform'
})

export class VideoConferenceService {
  api: any;
  domain = iNet.mediaPath ? (new URL(iNet.mediaPath)).host : 'jitsi.inetcloud.vn';
  messageJoin = {app: 'iChat', conferenceID: '', sender: '', joined: '', inAccess: ''};
  uriMessage = 'uri_message';
  videoConference = "video_conference";
  videoElement!: Element | any;
  private apiLoaded: boolean= false;

  constructor(private httpService: HttpClientService, private coreService: CoreService) {
    this.createElement();
    this.loadExternalAPI();
  }

  loadExternalAPI() {
    if (!this.apiLoaded) {
      iNet.loadScript('https://cdn.inetcloud.vn/data/products/unicorn/vendor/external_api.js', ()=> {
        //console.log('JitsiMeet Api ready');
        this.apiLoaded = true;

      });
    }
  }

  createElement() {
    const elementId = 'app-video-conference';
    let videoElement: any = document.getElementById(elementId);
    if(!videoElement) {
      videoElement = document.createElement('div');
      videoElement.id = elementId;
      videoElement.className = "container-video";
      document.body.appendChild(videoElement);
    }
    videoElement.style.visibility = "hidden";
    this.videoElement = videoElement;
  }

  getVideoElement(): Element | any {
    return this.videoElement;
  }

  join(parentNode: any, roomName: string, audioOnly: boolean = false, height: number = 350, callback?: Function) {
    if (!JitsiMeetExternalAPI) {
      return;
    }

    if(this.domain && this.domain.length > 0) {
      this.joinMeeting(parentNode, roomName, audioOnly, height, () => {
        if (callback) {
          callback(null);
        }
      }, () => {
        if (callback) {
          callback(this.api);
        }
      });
    }
  }

  callTo(parentNode: any, userName: string, audioOnly: boolean = false, height: number = 350, callback?: Function) {
    this.endToEnd(userName).subscribe((data) => {
      if (data.type !== ErrorMessage.TYPE) {
        let conferenceID = data.conferenceID || '';
        if (!iNet.isEmpty(conferenceID)) {
          if (!JitsiMeetExternalAPI) {
            return;
          }

          this.joinMeeting(parentNode, conferenceID, audioOnly, height, () => {
            if (callback) {
              callback(null);
            }
          }, () => {
            this.messageJoin.sender = iNet.username;
            this.messageJoin.conferenceID = conferenceID;
            if (callback) {
              let messageJSON = {sender: iNet.username, conferenceID: conferenceID};
              let __messageStr = 'uri_message:video_conference:' + this.encodeBase64(JSON.stringify(messageJSON)) || '';
              callback(this.api, __messageStr);
            }
          });
        }
      }
    });
  }

  getApi() {
    return this.api;
  }

  dispose() {
    if (this.getApi()) {
      this.api.dispose();
      delete this.api;
    }
  }

  getMessageJoin() {
    return this.messageJoin;
  }

  getRoomNameByReceiver(receiver: string): string {
    return iNet.username.split('@')[0] + '_' + receiver.split('@')[0];
  }

  isExistMeet() {
    return this.apiLoaded && !!JitsiMeetExternalAPI;
  }

  encodeBase64(str: string) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  decodeBase64(str: string) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  convertMessage(message: string): ConferenceMessage | null {
    let index = message.indexOf(this.uriMessage);
    if(index > -1){
      let args = message.split(":");
      if(args && args.length > 0 && args.length == 3){
        let type = args[1];
        if(type == this.videoConference){
          // Decode base64 data(jsonString)
          let data = this.decodeBase64(args[2]);
          let object = JSON.parse(data);
          return new ConferenceMessage(object);
        }
      }
    }
    return null;
  }

  private joinMeeting(parentNode: any, roomName: string, audioOnly: boolean = false, height: number = 350, onError: Function, onSuccess: Function): void {
    this.getJwToken(roomName).subscribe((data) => {
      let tokenId;
      const token = data['webdata'];
      if (token && token != "FAIL") {
        tokenId = token;
      }

      if (!tokenId) {
        if (onError) {
          onError();
        }
        return;
      }

      this.dispose();
      console.log('tokenId',tokenId);
      const options = this.buildMeetingOptions(tokenId, parentNode, roomName, audioOnly);

      // Init JitsiMeetExternalAPI
      this.api = new JitsiMeetExternalAPI(this.domain, options);

      if (onSuccess) {
        onSuccess();
      }

      this.executeCommands();
    });
  }

  private buildMeetingOptions(tokenId: string, parentNode: any, roomName: string, audioOnly: boolean = false): any {
    const options: any = {
      roomName: roomName,
      width: '100%',
      height: '100%',
      parentNode: parentNode,
      jwt: tokenId

    };
    if (audioOnly) {
      options.height = '100%';
      options['configOverwrite'] = {
        subject: ' ',
        enableWelcomePage: false,
        startAudioOnly: false,
        startWithAudioMuted: false,
        startWithVideoMuted: false
      }
    }
    return options;
  }

  private getJwToken(conferenceID: string): Observable<any> {
    return this.httpService.postJSON(iNet.getPUrl('conference/authorized'), {roomID: conferenceID});
  }

  private endToEnd(userName: string): Observable<any> {
    return this.httpService.postJSON(iNet.getPUrl('conference/end2end'), {callTo: userName});
  }

  private executeCommands(): void {
    this.executeCommand('sendTones', {
      tones: '12345#', // The dial pad touch tones to play. For example, '12345#'.
      duration: 200, // Optional. The number of milliseconds each tone should play. The default is 200.
      pause: 200 // Optional. The number of milliseconds between each tone. The default is 200.
    });

    this.executeCommand('displayName', iNet.displayName);
    this.executeCommand('email', iNet.username);
    this.executeCommand('avatarUrl', this.coreService.getAvatar(iNet.username));
    // this.executeCommand('setVideoQuality', 720);
  }

  private executeCommand(command: string, options: any) {
    let api = this.getApi();
    if (!api) {
      return;
    }
    api.executeCommand(command, options);
  }
}

export class ConferenceMessage {
  sender?: string;
  conferenceID?: string;
  action?: string;
  params: any;

  constructor(options: any) {
    this.params = Object.assign({}, options);
    Object.assign(this, options);
    console.log('Init ConferenceMessage', this);
  }
}


